import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { domainValueList } from "../../../../../../../services/domainValue.service";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";

const translationPath = "components.messages.";
const SURGERY_AUTOMATION_CODE = "35";

export const SurgeryCareCharacterField = memo(() => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectType[]>([]);
  const { sendRequest } = useFetch(domainValueList);
  const { automation } = useAutomationRules();

  const params = useMemo(() => ({ Identifier: "1016" }), []);

  const fetchOptions = useCallback(async () => {
    if (String(automation?.code) !== SURGERY_AUTOMATION_CODE) return;

    const { data, success } = await sendRequest(params);
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: item.identifierValue,
          name: item.domainValueName,
        })),
      );
    }
  }, [automation?.code, params, sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  if (String(automation?.code) !== SURGERY_AUTOMATION_CODE) return null;

  return (
    <Grid item xs={12} sm={12}>
      <AutoCompleteMulti
        params={params}
        fullWidth
        options={options}
        name="surgeryCareCharacters"
        label={t(translationPath + "surgeryCareCharacters")}
        getOptionLabel={(option) => option.name}
        size="small"
      />
    </Grid>
  );
});
